import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";

import bflHelper from "./bflHelper";
import { IBFModule, IBFResult, IKontrollResultRow, IKontrollResultRowDriftoptimering } from "../../types/BFL/Funktionskontroll";
import { IModuleByggnadsdata, IModuleKylaVattenburet, IModuleLokaler, IModuleVärmeEl } from "../../types/ModuleDatas";
import { IJ12_BFData } from "../../types/BFDatas";

const getVärmekällaFromModultypId = (modTypId: ModuleTypeId) => {
  switch (modTypId) {
    case ModuleTypeId.VarmeElAirotemper:
      return "EL airotemper";
    case ModuleTypeId.VarmeElGolvvarme:
      return "Elektrisk golvvärme";
    case ModuleTypeId.VarmeElRadiatorer:
      return "Elradiatorer";
    case ModuleTypeId.VarmeElStralningsvarmare:
      return "Strålningsvärmare";
    case ModuleTypeId.VarmeElVarmepump:
      return "Värmepump Luft / Luft";

    default:
      return "Okänd!?!?";
  }
};
//todo -> make class?!
export const bfv_J12 = (): IBFModule => {
  const bfName = BFLType.BFV_J12;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData, formData: any): IBFResult => {
    try {
      let funktionsKontroller: IKontrollResultRow[] = [];
      let driftOptimeringar: IKontrollResultRowDriftoptimering[] = [];
      let nyttVärdeVärmestopp: number | undefined = undefined;
      const debug: any = {};
      formData = (formData?.data || module.bfs?.BFV_J12?.data) as IJ12_BFData | undefined;

      if (module?.data && globalData?.Byggnadsdata) {
        const moduleData: IModuleVärmeEl = module.data;
        const roundData = roundHandler.getRoundData();
        const byggnadsData = roundData?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata)?.data as IModuleByggnadsdata;
        const rumOchLokaler = roundData?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Lokaler)?.data as IModuleLokaler;

        const systemAndel = moduleData.värmeSystemandel / 100;
        const byggnadArea = byggnadsData.byggnadArea;

        const kontrollVärmestoppFungerar = moduleData.kontrollVärmestoppFungerar;
        const kontrollGivareUtetemperaturFungerar = moduleData.kontrollGivareUtetemperaturFungerar;

        const kylSystemMedGemensamBetjäningsyta = roundData?.data.modules.filter(
          (m) => m.moduleTypeId === ModuleTypeId.KylaVattenburet && (m.data as IModuleKylaVattenburet).värmeSystemGemensamBetjäningsyta?.find((r) => r.värmeModulId === module.id)
        );
        let kylSystemStörstGemensamYta: IModuleRound | undefined = undefined;
        let ytaProcentSomBetjänasMedKomfortKyla = 0;
        if (kylSystemMedGemensamBetjäningsyta?.length) {
          for (var mi = 0; mi < kylSystemMedGemensamBetjäningsyta?.length; mi++) {
            const modKylSystem = kylSystemMedGemensamBetjäningsyta[mi];
            const gemensamBetjäningsytaAndel = (modKylSystem.data as IModuleKylaVattenburet).värmeSystemGemensamBetjäningsyta.find((g) => g.värmeModulId === module.id);
            if (gemensamBetjäningsytaAndel?.ytaAndel && gemensamBetjäningsytaAndel?.ytaAndel > ytaProcentSomBetjänasMedKomfortKyla) {
              kylSystemStörstGemensamYta = modKylSystem;
              ytaProcentSomBetjänasMedKomfortKyla = gemensamBetjäningsytaAndel.ytaAndel;
            }
          }
        }

        ytaProcentSomBetjänasMedKomfortKyla = ytaProcentSomBetjänasMedKomfortKyla / 100;

        //TODO Check this!
        const kylForm = (kylSystemStörstGemensamYta?.data as IModuleKylaVattenburet)?.kylform;
        let kylfaktor = 1;
        let kylfaktorFJV = 1;
        if (kylSystemStörstGemensamYta) {
          const foundKylfaktorRow = globalData.Kyla.Kylform_Faktor.find((r) => r.Kylform === kylForm);
          if (foundKylfaktorRow) {
            kylfaktor = foundKylfaktorRow.Faktor;
            kylfaktorFJV = foundKylfaktorRow.FJV;
          }
        }

        const schablonEnergiKyla = bimHandler.BIM_Schablon_EnergiKyla;

        const rowsInRumOchLokaler = rumOchLokaler.stickprov?.filter((r) => r.värmeSystem === module.name);
        const harKylaAktiv = rowsInRumOchLokaler.find((r) => r.komfortKylaAktiv === "Ja") ? "Ja" : "Nej";

        //77 : =byggnadArea*systemAndel*j12_kylSystemStörstGemensamYta*j12_schablonEnergiKyla/j12_kylfaktor
        const normalEnergiAnvändningKyla = (byggnadArea * systemAndel * ytaProcentSomBetjänasMedKomfortKyla * schablonEnergiKyla) / kylfaktor;

        const zon = moduleData.betjäningsområde;

        const gränsvärdeFunktionsfelVärmestopp = bimHandler.BIM_Pumpstopp_UteTemperatur;

        //j12_gränsvärdeVärmestopp = =IF(j12_kontrollVärmestoppFungerar="Ja";'Grunddata IN'!E70;j12_gränsvädeFunktionsfelVärmestopp)
        const gränsvärdeVärmestopp = kontrollVärmestoppFungerar === "Ja" ? moduleData.värmestoppInställningsvärde : gränsvärdeFunktionsfelVärmestopp;
        const gränsvärdeVärmestoppAvrundat = Math.round(gränsvärdeVärmestopp);

        const gränsvärdeVärmestoppOptimerat = bimHandler.BIM_Schablon_TempOptimeratPumpstopp; //='Grunddata BIM'!G34
        const geografiskJusteringsfaktor = bimHandler.G11_GeografiskJusteringsFaktor;
        const årligEnergiTransmission = bimHandler.BIM_ÅrligBruttoTransmission();

        const c5 = gränsvärdeVärmestoppOptimerat < 17 ? (17 - gränsvärdeVärmestoppOptimerat) * 8000 : 0; //=IF(j12_gränsvärdeVärmestoppOptimerat<17;17-j12_gränsvärdeVärmestoppOptimerat)*8000
        const c6 = gränsvärdeVärmestoppOptimerat < 18 && gränsvärdeVärmestoppAvrundat >= 17 ? 8000 : 0; //=IF(j12_gränsvärdeVärmestoppOptimerat<19*(AND(j12_gränsvärdeVärmestoppAvrundat>18));6500;0)
        const c7 = gränsvärdeVärmestoppOptimerat < 19 && gränsvärdeVärmestoppAvrundat >= 18 ? 6500 : 0; //=IF(j12_gränsvärdeVärmestoppOptimerat<19*(AND(j12_gränsvärdeVärmestoppAvrundat>18));6500;0)
        const c8 = gränsvärdeVärmestoppOptimerat < 20 && gränsvärdeVärmestoppAvrundat >= 19 ? 4500 : 0;
        const c9 = gränsvärdeVärmestoppOptimerat < 21 && gränsvärdeVärmestoppAvrundat >= 20 ? 1500 : 0;

        const sumGraderCH = geografiskJusteringsfaktor ? (c5 + c6 + c7 + c8 + c9) / geografiskJusteringsfaktor : 0;
        const andelAvTotalCh = sumGraderCH / 131600;
        const värmekälla = getVärmekällaFromModultypId(module.moduleTypeId);
        const vägledandeVerkningsgrad = module.moduleTypeId === ModuleTypeId.VarmeElVarmepump ? 2 : 1;
        const harCentraltVärmestopp = moduleData.harÖverordnatVärmestopp;

        const överkonsumtionElVärme = (årligEnergiTransmission * systemAndel * andelAvTotalCh) / vägledandeVerkningsgrad; // j12_överkonsumtionElVärme =j12_årligEnergiTransmission*j12_systemAndel*j12_andelAvTotalCh/j12_vägledandeVerkningsgrad

        //         j12_överkonsumtionKylaElproducerad
        // IF(kylForm != "Fjärrkyla" && j12_harKylaAktiv == "Ja" && j12_överkonsumtionElVärme>0,5)
        // (j12_årligEnergiTransmission*j12_systemAndel*j12_andelAvTotalCh)/j12_kylfaktor*j12_kylSystemStörstGemensamYta;
        // Else 0

        const överkonsumtionKylaElproducerad =
          kylForm !== "Fjärrkyla" && harKylaAktiv === "Ja" && överkonsumtionElVärme > 0.5
            ? ((årligEnergiTransmission * systemAndel * andelAvTotalCh) / kylfaktor) * ytaProcentSomBetjänasMedKomfortKyla
            : 0;
        //j12_överkonsumtionKylaFjärr = IF(AND(j12_harKylaAktiv="Ja";$B$70=$W$8;j12_överkonsumtionElVärme>0,5);(j12_årligEnergiTransmission*j12_systemAndel*j12_andelAvTotalCh)/j12_kylfaktor*j12_kylSystemStörstGemensamYta;0)
        const överkonsumtionKylaFjärr =
          harKylaAktiv === "Ja" && kylForm === "Fjärrkyla" && överkonsumtionElVärme > 0.5
            ? ((årligEnergiTransmission * systemAndel * andelAvTotalCh) / kylfaktor) * ytaProcentSomBetjänasMedKomfortKyla
            : 0;

        //j12_överkonsumtionKylaAbsorbtion : =IF(AND(j12_harKylaAktiv="Ja";kylForm === "Absorptionskyla";j12_överkonsumtionElVärme>0,5);(j12_årligEnergiTransmission*j12_systemAndel*j12_andelAvTotalCh)/j12_kylfaktorFJV*j12_kylSystemStörstGemensamYta;0)
        const överkonsumtionKylaAbsorbtion =
          harKylaAktiv === "Ja" && kylForm === "Absorptionskyla" && överkonsumtionElVärme > 0.5
            ? ((årligEnergiTransmission * systemAndel * andelAvTotalCh) / kylfaktorFJV) * ytaProcentSomBetjänasMedKomfortKyla
            : 0;

        debug["Beräkning komfortkyla till funktionskontroll och driftoptimering ovan"] = {
          zon,
          //kylform: (kylSystemStörstGemensamYta?.data as IModuleKylaVattenburet | undefined)?.kylform,
          kylfaktor,
          schablonEnergiKyla,
          ytaProcentSomBetjänasMedKomfortKyla,
          harKylaAktiv,
          kylfaktorFJV,
          normalEnergiAnvändningKyla,
          överkonsumtionKylaElproducerad,
          överkonsumtionKylaFjärr,
          överkonsumtionKylaAbsorbtion,
        };
        debug["Besparingspotential & Funktionskontroll värmestopp"] = {
          zon,
          gränsvärdeVärmestopp,
          gränsvärdeVärmestoppAvrundat,
          gränsvärdeVärmestoppOptimerat,
          geografiskJusteringsfaktor,
          årligEnergiTransmission,
          systemAndel: (systemAndel * 100).toString() + "%",
          sumGraderCH,
          andelAvTotalCh,
          värmekälla,
          vägledandeVerkningsgrad,
          harCentraltVärmestopp,
          överkonsumtionElVärme,
          överkonsumtionKylaElproducerad,
          överkonsumtionKylaFjärr,
          överkonsumtionKylaAbsorbtion,
        };

        const condtionFK13_värmestoppSaknas = moduleData.harÖverordnatVärmestopp === "Nej";
        const condtionFK7_värmestoppFinnsOchFungerar = !condtionFK13_värmestoppSaknas && kontrollVärmestoppFungerar === "Ja";
        const kwPerYear_FK1 = condtionFK7_värmestoppFinnsOchFungerar && !condtionFK13_värmestoppSaknas ? överkonsumtionElVärme : 0; //=IF(AND(j12_condtionFK7=1;j12_condtionFK13=0);j12_överkonsumtionElVärme;0)
        const kwPerYear_FK2 = !condtionFK7_värmestoppFinnsOchFungerar || !condtionFK13_värmestoppSaknas ? överkonsumtionElVärme : 0; //=IF(OR(j12_condtionFK7=0;j12_condtionFK13=1);j12_överkonsumtionElVärme;0)
        const condtionFK6_gränsvärdeOptimerat = kwPerYear_FK1 + kwPerYear_FK2 === 0;
        const condtionFK9_värmeAvgivning = moduleData.värmestoppFunktionskontroll === "Värmeavgivning aktiv";
        const condtionFK10_EjVärmeAvgivning = moduleData.värmestoppFunktionskontroll === "Värmeavgivning ej aktiv";
        const condtionFK11_harKyla = harKylaAktiv === "Ja";
        const condtionFK12 = condtionFK9_värmeAvgivning && condtionFK11_harKyla; //=IF(j12_condtionFK9+j12_condtionFK11=2;1;0)
        const condtionFK14_felvisandeTempGivare = kontrollGivareUtetemperaturFungerar !== "Ja";

        debug["Värden i F28:F38"] = {
          kwPerYear_FK1,
          kwPerYear_FK2,
        };

        debug["Villkor använda i formler (P2:U10)"] = {
          condtionFK6_gränsvärdeOptimerat,
          condtionFK7_värmestoppFinnsOchFungerar,
          condtionFK9_värmeAvgivning,
          condtionFK10_EjVärmeAvgivning,
          condtionFK11_harKyla,
          condtionFK12,
          condtionFK13_värmestoppSaknas,
          condtionFK14_felvisandeTempGivare,
        };
        //t1
        if (överkonsumtionElVärme > 0) {
          if (kwPerYear_FK1 === överkonsumtionElVärme) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 1, överkonsumtionElVärme, "Värme (El)"));
          // funktionsKontroller.push({
          //   index: 1,
          //   kWhs: överkonsumtionElVärme,
          //   energiSlag: "Värme (El)",
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ12_FKText1,
          // });
          else if (kwPerYear_FK2 === överkonsumtionElVärme) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 2, överkonsumtionElVärme, "Värme (El)"));
          // funktionsKontroller.push({
          //   index: 2,
          //   kWhs: överkonsumtionElVärme,
          //   energiSlag: "Värme (El)",
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ12_FKText2,
          // });
        }
        //t2
        if (överkonsumtionKylaElproducerad > 0) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 3, överkonsumtionKylaElproducerad, "Kyla (El)"));
          // funktionsKontroller.push({
          //   index: 3,
          //   kWhs: överkonsumtionKylaElproducerad,
          //   energiSlag: "Kyla (El)",
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ12_FKText3,
          // });
        }
        //t3
        if (överkonsumtionKylaFjärr > 0) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, överkonsumtionKylaFjärr, "Kyla (FJK)"));
          // funktionsKontroller.push({
          //   index: 4,
          //   kWhs: överkonsumtionKylaFjärr,
          //   energiSlag: "Kyla (FJK)",
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ12_FKText4,
          // });
        }
        //t4
        if (överkonsumtionKylaAbsorbtion > 0) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, överkonsumtionKylaAbsorbtion, "Kyla (FJV)"));
          // funktionsKontroller.push({
          //   index: 5,
          //   kWhs: överkonsumtionKylaAbsorbtion,
          //   energiSlag: "Kyla (FJV)",
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ12_FKText5,
          // });
        }
        //t5
        if (condtionFK6_gränsvärdeOptimerat) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 6, undefined, ""));
          // funktionsKontroller.push({
          //   index: 6,
          //   kWhs: undefined,
          //   energiSlag: "",
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ12_FKText6,
          // });
        }
        //t6
        if (condtionFK7_värmestoppFinnsOchFungerar) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 7, undefined, ""));
          // funktionsKontroller.push({
          //   index: 7,
          //   kWhs: undefined,
          //   energiSlag: "",
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ12_FKText7,
          // });
        }
        //t7
        if (condtionFK14_felvisandeTempGivare) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 14, undefined, ""));
          // funktionsKontroller.push({
          //   index: 14,
          //   kWhs: undefined,
          //   energiSlag: "",
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ12_FKText14,
          // });
        }
        //t8
        if (condtionFK12) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 12, undefined, ""));
          // funktionsKontroller.push({
          //   index: 12,
          //   kWhs: undefined,
          //   energiSlag: "",
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ12_FKText12,
          // });
        }
        //Tabell 2 Besparingspotential värme/kyla för nytt inställningsvärde värmestopp
        let utförtÄndringNyttVärmestopp =
          formData?.harAngettNyInställningVärmestopp === "Ja" && formData?.nyttVärdeVärmestopp !== undefined && formData?.nyttVärdeVärmestopp !== null;
        nyttVärdeVärmestopp = formData?.nyttVärdeVärmestopp;
        if (moduleData.kontrollVärmestoppFungerar === "Nej") {
          nyttVärdeVärmestopp = undefined;
          utförtÄndringNyttVärmestopp = false;
        }
        let andelAvTotalCh2 = 0;

        if (nyttVärdeVärmestopp !== undefined && nyttVärdeVärmestopp !== null) {
          const c30 = nyttVärdeVärmestopp < 17 ? (17 - nyttVärdeVärmestopp) * 8000 : 0;

          const c31 = nyttVärdeVärmestopp < 18 && nyttVärdeVärmestopp >= 17 ? 8000 : 0;

          const c32 = nyttVärdeVärmestopp < 19 && nyttVärdeVärmestopp >= 18 ? 6500 : 0;
          const c33 = nyttVärdeVärmestopp < 20 && nyttVärdeVärmestopp >= 19 ? 4500 : 0;
          const c34 = nyttVärdeVärmestopp < 21 && nyttVärdeVärmestopp >= 20 ? 1500 : 0;
          const sumGraderCH2 = geografiskJusteringsfaktor ? (c30 + c31 + c32 + c33 + c34) / geografiskJusteringsfaktor : 0;
          andelAvTotalCh2 = sumGraderCH2 / 131600;

          //B39 (j12_besparingspotential_förändringElVärme_NyttVärmestopp) : =IF(AND(j12_nyttVärdeVärmestopp<j12_gränsvärdeVärmestoppAvrundat;j12_utförtÄndringNyttVärmestopp="Ja";j12_kontrollVärmestoppFungerar="Ja");BIM_ÅrligBruttoTransmission*'Grunddata IN'!A70*j12_2_andelAvTotalCh/j12_vägledandeVerkningsgrad;0)
          const besparingspotential_förändringElVärme_NyttVärmestopp =
            nyttVärdeVärmestopp < gränsvärdeVärmestoppAvrundat && utförtÄndringNyttVärmestopp && kontrollVärmestoppFungerar === "Ja"
              ? (årligEnergiTransmission * systemAndel * andelAvTotalCh2) / vägledandeVerkningsgrad
              : 0;

          const förändringElVärme_NyttVärmestopp =
            utförtÄndringNyttVärmestopp && nyttVärdeVärmestopp > gränsvärdeVärmestoppAvrundat
              ? (årligEnergiTransmission * systemAndel * andelAvTotalCh) / vägledandeVerkningsgrad
              : 0;

          //j12_besparingspotential_förändringElKyla_NyttVärmestopp : =IF(AND(NOT(kylForm="Fjärrkyla");AND(j12_harKylaAktiv="Ja";j12_kontrollVärmestoppFungerar="Ja";j12_2_andelAvTotalCh>0,005;$j12_nyttVärdeVärmestopp>j12_gränsvärdeVärmestoppAvrundat));(BIM_ÅrligBruttoTransmission*systemAndel*j12_2_andelAvTotalCh)/j12_kylfaktor*j12_kylSystemStörstGemensamYta;0)
          const besparingspotential_förändringElKyla_NyttVärmestopp =
            kylForm !== "Fjärrkyla" && harKylaAktiv === "Ja" && kontrollVärmestoppFungerar === "Ja" && andelAvTotalCh2 > 0.005 && nyttVärdeVärmestopp > gränsvärdeVärmestoppAvrundat
              ? ((årligEnergiTransmission * systemAndel * andelAvTotalCh2) / kylfaktor) * ytaProcentSomBetjänasMedKomfortKyla
              : 0;

          //j12_besparingspotential_förändringFjärrkyla_NyttVärmestopp : =IF(AND(=> kylForm="Fjärrkyla";j12_harKylaAktiv="Ja";j12_kontrollVärmestoppFungerar="Ja";j12_2_andelAvTotalCh>0,005;j12_nyttVärdeVärmestopp>j12_gränsvärdeVärmestoppAvrundat);(BIM_ÅrligBruttoTransmission*systemAndel*j12_2_andelAvTotalCh)/j12_kylfaktor*j12_kylSystemStörstGemensamYta;0)
          const besparingspotential_förändringFjärrkyla_NyttVärmestopp =
            kylForm === "Fjärrkyla" && harKylaAktiv === "Ja" && kontrollVärmestoppFungerar === "Ja" && andelAvTotalCh2 > 0.005 && nyttVärdeVärmestopp > gränsvärdeVärmestoppAvrundat
              ? ((årligEnergiTransmission * systemAndel * andelAvTotalCh2) / kylfaktor) * ytaProcentSomBetjänasMedKomfortKyla
              : 0;

          //j12_besparingspotential_förändringAbsorbtionskyla_NyttVärmestopp =IF(AND(kylForm="Absorptionskyla";j12_harKylaAktiv="Ja";j12_kontrollVärmestoppFungerar="Ja";j12_2_andelAvTotalCh>0,005;j12_nyttVärdeVärmestopp>j12_gränsvärdeVärmestoppAvrundat);(BIM_ÅrligBruttoTransmission*systemAndel*j12_2_andelAvTotalCh)/j12_kylfaktorFJV*j12_kylSystemStörstGemensamYta;0)
          const besparingspotential_förändringAbsorbtionskyla_NyttVärmestopp =
            kylForm === "Absorptionskyla" &&
            harKylaAktiv === "Ja" &&
            kontrollVärmestoppFungerar === "Ja" &&
            andelAvTotalCh2 > 0.005 &&
            nyttVärdeVärmestopp > gränsvärdeVärmestoppAvrundat
              ? ((årligEnergiTransmission * systemAndel * andelAvTotalCh2) / kylfaktorFJV) * ytaProcentSomBetjänasMedKomfortKyla
              : 0;

          debug["Besparingspotential värme/kyla för nytt inställningsvärde värmestopp"] = {
            "15. Gränsvärde befintligt värmestopp": gränsvärdeVärmestoppAvrundat,
            "16. Gränsvärde värmestopp är optimerat ≤°C": gränsvärdeVärmestoppOptimerat,
            "17. Nytt gränsvärde värmestopp (°C)": nyttVärdeVärmestopp,
            "21. Andel av total °Ch": andelAvTotalCh2,
            "24. Förändring EL värme (kWh)": besparingspotential_förändringElVärme_NyttVärmestopp,
            "25. Förändring elproducerad kyla (kWh/år)": besparingspotential_förändringElKyla_NyttVärmestopp,
            "26. Förändring fjärrkyla (kWh/år)": besparingspotential_förändringFjärrkyla_NyttVärmestopp,
            "27. Förändring Absorptionskyla (kWh Fjärrvärme/år)": besparingspotential_förändringAbsorbtionskyla_NyttVärmestopp,
          };

          //Tabell 3 Ökad energianvändning värme/kyla nytt inställningsvärde värmestopp

          let andelAvTotalCh3 = 0;
          let ökadAnvändning_förändringElVärme_NyttVärmestopp = 0;

          //C52 : =IF(AND(j12_gränsvärdeVärmestoppAvrundat<17,1;j12_gränsvärdeVärmestoppAvrundat<j12_nyttVärdeVärmestopp);(17-j12_gränsvärdeVärmestoppAvrundat)*8000;0)
          const c52 = gränsvärdeVärmestoppAvrundat < 17 && gränsvärdeVärmestoppAvrundat < nyttVärdeVärmestopp ? (17 - gränsvärdeVärmestoppAvrundat) * 8000 : 0;
          //C53 : =IF(AND(j12_nyttVärdeVärmestopp>17,5;j12_gränsvärdeVärmestoppAvrundat<17,1);8000;0)
          const c53 = nyttVärdeVärmestopp > 17.5 && gränsvärdeVärmestoppAvrundat < 17.1 ? 8000 : 0;
          const c54 = nyttVärdeVärmestopp > 18.5 && gränsvärdeVärmestoppAvrundat < 18.1 ? 6500 : 0;
          const c55 = nyttVärdeVärmestopp > 19.5 && gränsvärdeVärmestoppAvrundat < 19.1 ? 4500 : 0;
          const c56 = nyttVärdeVärmestopp > 20.5 && gränsvärdeVärmestoppAvrundat < 20.1 ? 1500 : 0;

          const sumGraderCH3 = geografiskJusteringsfaktor ? (c52 + c53 + c54 + c55 + c56) / geografiskJusteringsfaktor : 0;
          andelAvTotalCh3 = sumGraderCH3 / 131600;

          //j12_ökadAnvändning_förändringElVärme_NyttVärmestopp : =IF(AND(j12_utförtÄndringNyttVärmestopp="Ja";j12_nyttVärdeVärmestopp>j12_gränsvärdeVärmestoppAvrundat);BIM_ÅrligBruttoTransmission*j12_3_systemAndel*j12_3_andelAvTotalCh/j12_vägledandeVerkningsgrad;0)
          ökadAnvändning_förändringElVärme_NyttVärmestopp =
            utförtÄndringNyttVärmestopp && nyttVärdeVärmestopp > gränsvärdeVärmestoppAvrundat
              ? (årligEnergiTransmission * systemAndel * andelAvTotalCh3) / vägledandeVerkningsgrad
              : 0;

          //j12_ökadAnvändning_förändringElKyla_NyttVärmestopp : =IF(AND(NOT(kylForm="Fjärrkyla");AND(j12_harKylaAktiv="Ja";j12_3_andelAvTotalCh>0,005;j12_nyttVärdeVärmestopp<j12_gränsvärdeVärmestoppAvrundat));(BIM_ÅrligBruttoTransmission*j12_3_systemAndel*j12_3_andelAvTotalCh)/j12_kylfaktor*j12_kylSystemStörstGemensamYta;0)
          const ökadAnvändning_förändringElKyla_NyttVärmestopp =
            kylForm !== "Fjärrkyla" && harKylaAktiv === "Ja" && andelAvTotalCh3 > 0.005 && nyttVärdeVärmestopp < gränsvärdeVärmestoppAvrundat
              ? ((årligEnergiTransmission * systemAndel * andelAvTotalCh3) / kylfaktor) * ytaProcentSomBetjänasMedKomfortKyla
              : 0;

          //j12_ökadAnvändning_förändringFjärrkyla_NyttVärmestopp : =IF(AND(kylForm="Fjärrkyla";j12_harKylaAktiv="Ja";j12_3_andelAvTotalCh>0,005;j12_nyttVärdeVärmestopp<j12_gränsvärdeVärmestoppAvrundat);(BIM_ÅrligBruttoTransmission*j12_3_systemAndel*j12_3_andelAvTotalCh)/j12_kylfaktor*j12_kylSystemStörstGemensamYta;0)
          const ökadAnvändning_förändringFjärrkyla_NyttVärmestopp =
            kylForm === "Fjärrkyla" && harKylaAktiv === "Ja" && andelAvTotalCh3 > 0.005 && nyttVärdeVärmestopp < gränsvärdeVärmestoppAvrundat
              ? ((årligEnergiTransmission * systemAndel * andelAvTotalCh3) / kylfaktor) * ytaProcentSomBetjänasMedKomfortKyla
              : 0;
          //j12_ökadAnvändning_förändringAbsorbtionskyla_NyttVärmestopp : =IF(AND(kylForm="Absorptionskyla";j12_harKylaAktiv="Ja";j12_3_andelAvTotalCh>0,005;j12_nyttVärdeVärmestopp<j12_gränsvärdeVärmestoppAvrundat);(BIM_ÅrligBruttoTransmission*j12_3_systemAndel*j12_3_andelAvTotalCh)/j12_kylfaktorFJV*j12_kylSystemStörstGemensamYta;0)
          const ökadAnvändning_förändringAbsorbtionskyla_NyttVärmestopp =
            kylForm === "Absorptionskyla" && harKylaAktiv === "Ja" && andelAvTotalCh3 > 0.005 && nyttVärdeVärmestopp < gränsvärdeVärmestoppAvrundat
              ? ((årligEnergiTransmission * systemAndel * andelAvTotalCh3) / kylfaktorFJV) * ytaProcentSomBetjänasMedKomfortKyla
              : 0;

          debug["Ökad energianvändning värme/kyla nytt inställningsvärde värmestopp"] = {
            "35. Andel av total °Ch": andelAvTotalCh3,
            "38. Förändring EL värme (kWh)": ökadAnvändning_förändringElVärme_NyttVärmestopp,
            "39. Förändring elproducerad kyla (kWh/år)": ökadAnvändning_förändringElKyla_NyttVärmestopp,
            "40. Förändring fjärrkyla (kWh/år)": ökadAnvändning_förändringFjärrkyla_NyttVärmestopp,
            "41. Förändring Absorptionskyla (kWh Fjärrvärme/år)": ökadAnvändning_förändringAbsorbtionskyla_NyttVärmestopp,
          };
          //t9
          if (besparingspotential_förändringElVärme_NyttVärmestopp > 0) {
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 1, besparingspotential_förändringElVärme_NyttVärmestopp, "Värme (EL)"));
            // driftOptimeringar.push({
            //   index: 1,
            //   kWhs: besparingspotential_förändringElVärme_NyttVärmestopp,
            //   energiSlag: "Värme (EL)",
            //   message: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText1.Text,
            //   inverteraTecken: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText1.InverteraTecken,
            // });
          }
          //t10
          if (ökadAnvändning_förändringElVärme_NyttVärmestopp > 0) {
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 5, ökadAnvändning_förändringElVärme_NyttVärmestopp, "Värme (EL)"));
            // driftOptimeringar.push({
            //   index: 5,
            //   kWhs: ökadAnvändning_förändringElVärme_NyttVärmestopp,
            //   energiSlag: "Värme (EL)",
            //   message: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText5.Text,
            //   inverteraTecken: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText5.InverteraTecken,
            // });
          }
          //t11
          if (besparingspotential_förändringElKyla_NyttVärmestopp > 0 || ökadAnvändning_förändringElKyla_NyttVärmestopp > 0) {
            if (besparingspotential_förändringElKyla_NyttVärmestopp > ökadAnvändning_förändringElKyla_NyttVärmestopp)
              driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 2, besparingspotential_förändringElKyla_NyttVärmestopp, "Kyla (EL)"));
            // driftOptimeringar.push({
            //   index: 2,
            //   kWhs: besparingspotential_förändringElKyla_NyttVärmestopp,
            //   energiSlag: "Kyla (EL)",
            //   message: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText2.Text,
            //   inverteraTecken: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText2.InverteraTecken,
            // });
            else driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 6, ökadAnvändning_förändringElKyla_NyttVärmestopp, "Kyla (EL)"));
            // driftOptimeringar.push({
            //   index: 6,
            //   kWhs: ökadAnvändning_förändringElKyla_NyttVärmestopp,
            //   energiSlag: "Kyla (EL)",
            //   message: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText6.Text,
            //   inverteraTecken: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText6.InverteraTecken,
            // });
          }

          if (besparingspotential_förändringFjärrkyla_NyttVärmestopp > 0 || ökadAnvändning_förändringFjärrkyla_NyttVärmestopp > 0) {
            if (besparingspotential_förändringFjärrkyla_NyttVärmestopp > ökadAnvändning_förändringFjärrkyla_NyttVärmestopp)
              driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 3, besparingspotential_förändringFjärrkyla_NyttVärmestopp, "Kyla (FJK)"));
            // driftOptimeringar.push({
            //   index: 3,
            //   kWhs: besparingspotential_förändringFjärrkyla_NyttVärmestopp,
            //   energiSlag: "Kyla (FJK)",
            //   message: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText3.Text,
            //   inverteraTecken: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText3.InverteraTecken,
            // });
            else driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 7, ökadAnvändning_förändringFjärrkyla_NyttVärmestopp, "Kyla (FJK)"));
            // driftOptimeringar.push({
            //   index: 7,
            //   kWhs: ökadAnvändning_förändringFjärrkyla_NyttVärmestopp,
            //   energiSlag: "Kyla (FJK)",
            //   message: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText7.Text,
            //   inverteraTecken: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText7.InverteraTecken,
            // });
          }

          if (besparingspotential_förändringAbsorbtionskyla_NyttVärmestopp > 0 || ökadAnvändning_förändringAbsorbtionskyla_NyttVärmestopp > 0) {
            if (besparingspotential_förändringAbsorbtionskyla_NyttVärmestopp > ökadAnvändning_förändringAbsorbtionskyla_NyttVärmestopp)
              driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 4, besparingspotential_förändringAbsorbtionskyla_NyttVärmestopp, "Kyla (FJV)"));
            // driftOptimeringar.push({
            //   index: 4,
            //   kWhs: besparingspotential_förändringAbsorbtionskyla_NyttVärmestopp,
            //   energiSlag: "Kyla (FJV)",
            //   message: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText4.Text,
            //   inverteraTecken: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText4.InverteraTecken,
            // });
            else driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 8, ökadAnvändning_förändringAbsorbtionskyla_NyttVärmestopp, "Kyla (FJV)"));
            // driftOptimeringar.push({
            //   index: 8,
            //   kWhs: ökadAnvändning_förändringAbsorbtionskyla_NyttVärmestopp,
            //   energiSlag: "Kyla (FJV)",
            //   message: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText8.Text,
            //   inverteraTecken: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ12_OptText8.InverteraTecken,
            // });
          }
        }
      }

      const bH = bflHelper.bflHelper();
      const dbg = formData;

      return {
        bfName: BFLType.BFV_J12,
        funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
        driftOptimeringar: bH.cleanDriftoptimeringar(driftOptimeringar),
        note: "",
        data: { ...formData },
        debug,
      };
    } catch (err: any) {
      return {
        bfName: BFLType.BFV_J12,
        funktionsKontroller: [],
        driftOptimeringar: [],
        note: "",
        data: {},
        debug: { Error: err },
        error: err,
      };
    }
  };
  /// transfers any formdata values to the bf data.
  const bflSpecificPrepareData = (module: IModuleRound, bfl: IBFResult, bflForm: IBFResult | undefined) => {
    if (!bfl) return;
    if (!bfl.data) bfl.data = { nyttVärdeVärmestopp: (module.data as IModuleVärmeEl)?.värmestoppInställningsvärde };
    if (bflForm?.data) {
      if ((module.data as IModuleVärmeEl)?.harÖverordnatVärmestopp === "Ja") {
        bfl.data.nyttVärdeVärmestopp = bflForm.data.nyttVärdeVärmestopp;
        bfl.data.harAngettNyInställningVärmestopp = bflForm.data.harAngettNyInställningVärmestopp;
      } else {
        bfl.data.nyttVärdeVärmestopp = undefined;
        bfl.data.harAngettNyInställningVärmestopp = "Nej";
      }
    }
  };

  //module public interface
  return {
    getResult: getResult,
    bflSpecificPrepareData,
    bfName,
  };
};

const dflt = { bfv_JX: bfv_J12 };

export default dflt;
